<template>
<div class="in-report-manage">
    <component :is="views"></component>
</div>
</template>

<script>
import rsList from '@/views/BannerManage/components/bannerList';
export default {
    data() {
        return {
            views: rsList
        }
    },
    methods: {},
    mounted() {}
}
</script>
